import { useHistory, useParams } from 'react-router-dom';
import { List } from 'immutable';
import Divider from 'flow/components/ui-components/Divider';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { ChannelLoginList, QueueLoginList } from 'flow/types/Profile';
import { routes } from 'flow/types/routes';
import { TypedMap } from 'flow/types/TypedMap';
import { generatePath } from 'flow/utils/router-utils';
import Page from '../Page';
import LiveChats from './QueueAndChatLogin/LiveChats';
import Queues from './QueueAndChatLogin/Queues';

const ProfileQueueAndChatLogin = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { extensionKey, profileKey } = useParams<{
        extensionKey: ExtensionKey;
        profileKey: ProfileKey;
    }>();
    const { profiles } = useProfiles(extensionKey);

    if (!profiles?.size) {
        return null;
    }

    const getTitle = () => {
        const listExistsOnProfile = (
            list:
                | List<TypedMap<ChannelLoginList>>
                | List<TypedMap<QueueLoginList>>,
        ) => !!list && !list.isEmpty();

        const hasChannel = profiles.some((profile) =>
            listExistsOnProfile(profile.get('channelLoginList')),
        );

        const hasQueue = profiles.some((profile) =>
            listExistsOnProfile(profile.get('queueLoginList')),
        );

        if ((hasChannel && hasQueue) || (!hasChannel && !hasQueue)) {
            return 'settings.queue_channel_login';
        }

        return hasChannel ? 'settings.channel_login' : 'settings.queue_login';
    };

    const getInfo = () => {
        const isMemberOfChannel = profiles.find(
            (profile) => !profile.get('channelLoginList').isEmpty(),
        );
        const isMemberOfQueue = profiles.find(
            (profile) => !profile.get('queueLoginList').isEmpty(),
        );

        if (
            (isMemberOfChannel && isMemberOfQueue) ||
            (!isMemberOfChannel && !isMemberOfQueue)
        ) {
            return i18next.t('settings.queue_channel_login.info');
        }

        return isMemberOfChannel
            ? i18next.t('settings.channel_login.info')
            : i18next.t('settings.queue_login.info');
    };

    return (
        <Page
            header={getTitle()}
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.profiles.profileKey'], {
                        extensionKey,
                        profileKey,
                    }),
                )
            }
        >
            <p
                className="mt-4 mb-6 ps-2"
                dangerouslySetInnerHTML={{
                    __html: getInfo(),
                }}
            />

            <Queues />

            <Divider />

            <LiveChats />
        </Page>
    );
};

export default ProfileQueueAndChatLogin;
